<template lang="pug">
  div
    .input-group(:class='inputGroupClass')
      input.form-control(type='text' :disabled='disabled' v-model="value")
      .input-addon
        div
          div(style='white-space: nowrap; padding: 0 10px;')
            | {{ currency }}
</template>


<script lang="ts" setup>

import {computed} from "vue";
import {CurrencyCode} from "@/models/core/currency";

const props = defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  currency: {
    type: String,
    default: CurrencyCode.USD,
  },
})

const inputGroupClass = computed(() => {
  return { 'disabled-input-group': props.disabled };
})

const emit = defineEmits(['input'])

const onInput = ($event: any) => {
  emit('input', $event.target.value);
}

const value = computed({
  get() {
    return props.value;
  },
  set(value: string) {
    emit('input', value);
  }
})
</script>

<style scoped>

</style>
